import React from 'react';
import TableCursos from './TableCursos/TableCursos';

const Cursos = () => {
  return <TableCursos/> ;
};

export default Cursos;
